import { useMemo } from "react";
import { LocationRead } from "@types";

export function useLocationOptions(locations: LocationRead[]) {
  return useMemo(
    () =>
      locations.map((loc) => ({
        label: loc.locationName ?? "Unnamed",
        value: loc.id!,
      })),
    [locations],
  );
}
